export default {
  lang: {
    selectAll: 'Vybrat všechny stránky',
    selected: 'Vybráno',
    term: 'Článek',
    deselect: 'Zrušit výběr',
  },
};
